import { render, staticRenderFns } from "./DetailPembayaran.vue?vue&type=template&id=2090d97e&"
import script from "./DetailPembayaran.vue?vue&type=script&lang=js&"
export * from "./DetailPembayaran.vue?vue&type=script&lang=js&"
import style0 from "./DetailPembayaran.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports